/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const useSystemConfigurationPageStyles = makeStyles(() => ({
  root: {
    display: 'block',
    '& .MuiFormHelperText-root': {
      fontSize: '12px',
      lineHeight: '16px',
      padding: '0',
      '& .Mui-error': {
        color: '#FA634E',
      },
    },
  },
  title: {
    marginTop: '5px',
    marginBottom: '10px',
  },
  submitBtn: {
    marginTop: '15px',
  },
  modalError: {
    textAlign: 'left',
    whiteSpace: 'pre-wrap',
  },
}));
